import { useContext } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import UserContext from "../context/user";
import {
  // URL_PDF_ACQUISTO,
  URL_PDF_SERVICE,
  URL_PDF_AMICO,
} from "../utils/constants";

export const useCart = () => {
  const { userProfile, callApi } = useContext(UserContext);
  return useQuery({
    queryKey: ["cart", userProfile?.username],
    queryFn: () => callApi(`/api/ecommerce/cart`),
    select: (data) => {
      const allTitoli = data
        ? [
            ...data.titoli
              ?.filter((item) => item.titolo_stato === "valido")
              .map((item) => ({
                barcode: item.barcode,
                tck: item.tck,
                data: item.data,
                specie: item.specie,
                riduzione: item.riduzione,
                titolo_stato: item.titolo_stato,
                intestatario: {
                  nome:
                    item.intestatarioOnline?.nome || item.intestatario?.nome,
                  cognome:
                    item.intestatarioOnline?.cognome ||
                    item.intestatario?.cognome,
                },
              })),
            ...data.titoli_portafoglio
              ?.filter((item) => item.titolo_stato === "valido")
              .map((item) => ({
                barcode: item.barcode,
                codice: `${item.pin_pratica}#${item.id}`,
                pin_pratica: item.pin_pratica,
                tck: item.tck,
                data: item.data,
                riduzione: item.riduzione,
                titolo_stato: item.titolo_stato,
                specie: item.id_pratica ? "O" : item.specie || item.titolo_tipo,
                intestatario: {
                  nome:
                    item.intestatario?.nome || item.intestatarioOnline?.nome,
                  cognome:
                    item.intestatario?.cognome ||
                    item.intestatarioOnline?.cognome,
                },
              })),
          ]
        : [];
      return {
        id_carrello: data.id_carrello,
        id_cliente: data.id_cliente,
        prenotazioni_tot: data.prenotazioni_tot,
        prenotazioni_free: data.prenotazioni_free,
        costo: data.costo,
        titoli: allTitoli,
        book: data.book,
      };
    },
    enabled: !!userProfile,
  });
};

export const useListaAcquisti = () => {
  const { userProfile, callApi, isAmico } = useContext(UserContext);
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["ordini", userProfile?.username],
    queryFn: () => callApi(`api/ecommerce/lista-acquisti`),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["cart", userProfile?.username]);
    },
    select: (data) => {
      if (isAmico && data.data?.id_amico) {
        console.log("data amico", data.data);
        const url = `${URL_PDF_AMICO}?id=${data.data.id_amico}`;
        const pdf = `${URL_PDF_SERVICE}?url=${encodeURIComponent(url)}`;
        data.data.pdf = pdf;
        return data.data;
      } else {
        // return data?.data?.titoli.map((obj) => {
        //   const pdf = ``;
        //   return { ...obj, pdf };
        // });
        return {
          acquisti: data?.data?.acquisti
            ?.filter((item) => item.stato === "pagato" && item.book.length > 0)
            .map((acquisto) => ({
              id_carrello: acquisto.id_carrello,
              book: acquisto.book,
              data: acquisto.data,
              code: acquisto.acquisto_pin,
            })),
          titoli: data?.data?.titoli,
          titoli_portafoglio: data?.data.titoli_portafoglio,
        };
      }
    },
    enabled: !!userProfile,
    staleTime: 0,
  });
};

export const useConfermaAcquisto = () => {
  const queryClient = useQueryClient();
  const { callApi, userProfile } = useContext(UserContext);
  const acquisto = useMutation(
    (data) => {
      return callApi("/api/ecommerce/conferma-acquisto", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["cart", userProfile?.username]);
      },
    },
  );
  return acquisto;
};

export const useAddTicket = () => {
  const queryClient = useQueryClient();
  const { callApi, userProfile } = useContext(UserContext);
  const addTicket = useMutation(
    (data) => {
      return callApi("/api/ecommerce/add-ticket", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(["cart", userProfile?.username], data.data);
      },
    },
  );
  return addTicket;
};

export const useSetBooking = () => {
  const queryClient = useQueryClient();
  const { callApi, userProfile } = useContext(UserContext);
  const setBooking = useMutation(
    (data) => {
      return callApi("/api/ecommerce/set-booking", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(["cart", userProfile?.username], data.data);
      },
    },
  );
  return setBooking;
};
